module.exports = __webpack_public_path__ + "img/202509-2_03.c37bfb21.jpg";